import type { Question } from '@exam-management/common/qcontent-provider';
import { TagCategory } from '@exam-management/graphql';

import type { QContentDetailFormContextData } from '../types';

export function getCognitiveDomain(tags: Question['tags']) {
  const cognitiveDomain: QContentDetailFormContextData['properties']['cognitiveDomain'] = [];
  for (const tag of tags) {
    if (tag.category === TagCategory.CognitiveDomain) {
      cognitiveDomain.push({ label: tag.name, value: tag.id });
    }
  }
  return cognitiveDomain;
}
